// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-773fa6e0] {\n  fill: #fff\n}\n.st39[data-v-773fa6e0] {\n  fill: #7ed700\n}\n", ""]);
// Exports
module.exports = exports;
